import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Renderer2,
  ElementRef,
  ViewChild,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { RouterService } from "src/app/libs/data-access/services/router/router.service";
import {
  SortValueEnum,
  SortValueFlightEnum,
} from "src/app/libs/ui/components/top-bar/enums/top-bar.enum";
import { TimeUtil } from "src/app/libs/ui/utils/time.utils";
import { PagesRoute } from "src/app/pages/src/app/ui/routes/routes.enum";
import { FlightsFacade } from "../data-access/services/flights.facade";
import { FlightPageUtils } from "../data-access/utils/flights-page.utils";
import { parseDuration, parseLocation } from "./utils/flights-page.utils";
import { HomePageUtils } from "src/app/pages/home-page/src/app/ui/utils/home-page.utils";
import { TokenStorageService } from "src/app/core/services/token-storage.service";
import { FlightFiltersComponent } from "./components/flight-filters/flight-filters.component";
import { EventsFacade } from "src/app/pages/events/src/app/data-access/services/events.facade";
import { CheckoutFacade } from "src/app/libs/data-access/services/checkout/services/checkout.facade";
import { DatePipe } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { FlightsStateActions } from "../data-access/store/flights.actions";
import { CountriesData, CountryData, SortOption, SortOptionsFlight } from "src/app/pages/events/src/app/ui/events-page.config";
import { FiltersPagesTypes } from "src/app/libs/ui/components/filters-panel/enums/filters-panel.enum";
import { FormsMetadata } from "src/app/libs/ui/components/search-form/consts/form-metadata.const";
import { FindTripFormGroupInterface } from "src/app/libs/ui/components/search-form/interfaces/form-metadata.interface";
import { FlightsFiltersApiKeyEnum, FlightsFilterTypeApiKeyEnum } from "../data-access/model/enums/flight-filter.enum";
import { PackageTypes } from "src/app/libs/data-access/models/consts/packageType.const";
import { ResetState } from "src/app/actions/global.actions";
import { IEventRequest } from "src/app/pages/events/src/app/data-access/model/interfaces/events-requests.interface";
import { EventRequest } from "src/app/pages/events/src/app/data-access/mocks/events-requests.mock";
import { TripSummaryComponent } from "src/app/libs/ui/components/trip-summary/trip-summary.component";
import { MatDialog } from "@angular/material/dialog";
import { OfflineDialogComponent } from "src/app/libs/ui/components/offline-dialog/offline-dialog.component";

@Component({
  selector: "tic-flights-page",
  templateUrl: "./flights-page.component.html",
  styleUrls: ["./flights-page.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
}) 

export class FlightsPageComponent {
  @ViewChild(FlightFiltersComponent) childComponent!: FlightFiltersComponent;
  @ViewChild("cheapest") cheapest!: ElementRef;
  @ViewChild("fastest", { static: true }) fastest!: ElementRef;
  @ViewChild("best", { static: true }) best!: ElementRef;
  readonly parseDuration = parseDuration;
  readonly parseLocation = parseLocation;
  readonly filtersPagesTypes = FiltersPagesTypes;
  packageType = PackageTypes;
  packageIndex!: number;
  showFillerAsDefault = false;
  params = { };
  private destroy$ = new Subject();
  data: any;
  flightResults: any = [];
  fixedFlightResults: any = [];
  isOpen = true;
  toggleflt = false;
  minPrice = 0;
  maxPrice = 100000;
  showsort = false;
  pspopup = false;
  loadedEvent: any = {};
  cheapestFlight: any = {};
  fastestFlight: any = {};
  bestFlight: any = {};
  sortVal: string = "total_amount";
  cartEventPrice!: string;
  cartEventCurrency!: string;
  flightId!: string;
  hotelId!: string;
  packageMetadata!: any;
  actcard = false;
  totalAmount: number = 0;
  totalAmountPp!: number;
  pageCount:number = 1; 
  selectedFilters: any = {};
  selectedSorting: string = this.sortVal;
  totalPeoples!: number;
  currency!: string;
  sortOptions: SortOption[] = SortOptionsFlight;
  rpp!: number;
  totalLeftToFetch!: number;
  loadedFlights!: any;
  allLoadedFlights!: any;
  quickFilterSelected!: any;
  totalShown: number = 0;
  showRetryBtn: boolean;
  isFilterFailed: boolean;
  prevFlightPrice: number;
  eventPrice: number = 0;
  hotelPrice: number = 0;
  public eventRequest: IEventRequest = EventRequest;
  countryData:CountryData[] = CountriesData;
  @Input() isSummaryPage:boolean=false;
  @Output() flightSummarySelection= new EventEmitter();
  searchType: string;

  constructor(
    private routerService: RouterService,
    private tokenStorage: TokenStorageService,
    public facade: FlightsFacade,
    public eventFacade: EventsFacade,
    private changeDetectorRef: ChangeDetectorRef,
    public facadeCheckout: CheckoutFacade,
    private router: Router,
    private globalStore: Store,
    public datePipe: DatePipe,
    public activatedRoute: ActivatedRoute,
    private matDiaLog: MatDialog,
  ) { 
    this.initializeComponentState();
    this.getFilterState();
  }

  private initializeComponentState(): void {
    // Subscribe to query parameters for dynamic updates
    this.activatedRoute.queryParams.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: any) => {
        this.data = res;
        this.params = { sort: SortValueEnum.TotalAmountAsc };
        // Decode and parse the flightFilter parameter if present
        if (this.data.flightFilter) {
          try {
            const base64Data = decodeURIComponent(this.data.flightFilter);
            const jsonString = atob(base64Data);
            const filterObj = JSON.parse(jsonString);
            this.params = { filterObj };
          } catch (error) {
            console.error('Error decoding flightFilter:', error);
          }
        }
  
        // Finalize the object data
        this.data = HomePageUtils.finalizedObjectData(this.data);
  
        // Add specific properties from query parameters
        this.data["eventOfferId"] = res["eventOfferId"];
        this.data["eventOfferPrice"] = res["eventOfferPrice"];
        this.data["eventOfferPriceCurrency"] = res["eventOfferPriceCurrency"];
        this.data["flightId"] = res["flightId"];
        this.data["hotelId"] = res["hotelId"];
        this.packageIndex = res["packageType"];
        this.searchType = res["searchType"];
        this.totalPeoples = parseInt(res["numberOfAdults"] || "0", 10) + parseInt(res["numberOfChildren"] || "0", 10);
  
        // Merge additional params if necessary
        this.params = { ...this.data, ...this.params };
  
        // Handle event offer logic
        if (this.data.eventOfferId) {
          this.cartEventCurrency = this.data.eventOfferPriceCurrency;
          this.cartEventPrice = this.data.eventOfferPrice;
  
          const eventOfferIds = this.data.eventOfferId.split(",");
          for (const eventId of eventOfferIds) {
            this.getEventsData(eventId);
          }
        }
  
        // Handle flightId and hotelId
        if (this.data.flightId) this.flightId = this.data.flightId;
        if (this.data.hotelId) this.hotelId = this.data.hotelId;
  
        // Load flights with the updated params
        this.loadFlights(this.params);
      },
      error: (error) => {
        console.error('Error fetching query parameters:', error);
        this.routerService.navigate(PagesRoute.HomePage);
      },
    });
  
    // Subscribe to VM state for flights
    this.facade.vm$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data?.active) {
        this.loadedFlights = data.active;
        this.allLoadedFlights = data.active;
        this.totalFlightVisible();
      }
    });
  
    // Subscribe to VM state for checkout
    this.facadeCheckout.vm$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data) {
        if (data.events?.length > 0) this.currency = data.events[0].currency;
        if (data.totalPrice) {
          this.totalAmount = data.totalPrice;
          this.totalAmountPp = data.totalPrice / this.totalPeoples;
        }
        if (data.flightPrice) this.prevFlightPrice = data.flightPrice;
        if (data.eventPrice) this.eventPrice = data.eventPrice;
        if (data.hotelPrice) this.hotelPrice = data.hotelPrice;
      }
    });
  }
  
  
  ngAfterViewInit(): void {
    const cheapest = this.cheapest?.nativeElement as HTMLDivElement;
    cheapest?.classList?.add("active");    
  }

  totalFlightVisible() {
    this.totalShown = 0;
    if(this.allLoadedFlights && this.allLoadedFlights.length > 0) {
      this.allLoadedFlights.forEach(flight => {
        this.totalShown++;
      });
    }
  }

  private loadFlights(data: any): void {
    //TODO: complete type
    let requestQuery = FlightPageUtils.getRequestQuery(data);
    this.rpp = requestQuery.flightsCriteria.metadata.rpp;
    this.facade.loadFilterOptions({
      createOfferRequest: requestQuery.flightsCriteria.createOfferRequest,
      searchParams: requestQuery.flightsCriteria.searchParams,
    });
    this.packageMetadata = {
      isPackage: true,
      persons: {
          adults: data.numberOfAdults,
          children: data.numberOfChildren,
          total: parseInt(data.numberOfAdults) + parseInt(data.numberOfChildren)
      }
    };
    let filters;
    if(data.filterObj) {
      filters = data.filterObj;
      this.selectedFilters = filters;
    } else {
      filters = {}
    }
    requestQuery = {
      ...requestQuery,
      flightId: this.flightId,
      packageMetadata: this.packageMetadata,
      filters: filters
    }
    this.facade.loadInitialFlightData(requestQuery);
  }

  onSelectedFlight(flightOfferParams: any, flight: any) {
    const { flightOfferId, flightOfferPrice } = flightOfferParams;
    const { flightOfferPriceCurrency } = flightOfferParams;
    this.data.inboundDate = this.data.inbound.date;
    this.data.outboundDate = this.data.outbound.date;
    this.data = HomePageUtils.finalizedObjectDataTemp(this.data);
    this.tokenStorage.saveData("flightPrice", flightOfferPrice);
    this.tokenStorage.saveData("currency", flightOfferPriceCurrency);
    let updatedTotalPrice;
    // if(this.prevFlightPrice) {
    //   updatedTotalPrice = (this.totalAmount - this.prevFlightPrice) + (flightOfferPrice*this.totalPeoples);
    // } else {
    //   updatedTotalPrice = this.totalAmount + (flightOfferPrice*this.totalPeoples);
    // }
    updatedTotalPrice = this.eventPrice + this.hotelPrice + parseFloat(flight.actual_amount);
    this.facadeCheckout.setTotalPrice(updatedTotalPrice);
    this.facadeCheckout.setFlight(flight);
    const flightPrice = parseFloat(flight.actual_amount);
    this.facadeCheckout.setFlightPrice(flightPrice);
    let forwardRoute = "";
    if (+this.data.packageType == 1 || +this.data.packageType == 3) {
      forwardRoute = PagesRoute.HotelsPage;
    } else if (+this.data.packageType == 2) {
      forwardRoute = PagesRoute.TripSummary;
    }
    this.routerService.navigateAndAddParamsToUrl(
      { ...this.data, flightId: flightOfferId },
      true,
      forwardRoute
    );
  }

  trackById(index: number, hotel: any): number | string {
    return hotel.id;
  }

  onScroll(event: any): void {
    this.totalLeftToFetch = event.totalRecordsLeft;
    if (event.totalRecordsLeft > 0) {
      event = JSON.parse(JSON.stringify(event));
      event.requestMetadata.flightsCriteria.metadata.page = ++this.pageCount;
      this.loadMoreFlights(event.requestMetadata);
    }
  }

  loadMoreFlights(event: any) {
    this.facade.loadMoreFlights(event);
  }

  onSort(event: SortValueFlightEnum): void {
    this.loadFlights({ ...this.params, sort: event });
  }

  onFilterSelected(event: any) {
    const object = this.filterToApiKey(event);
    this.params = { ...this.params, ...object };
    //this.loadFlights(this.params);
  }

  filterToApiKey(event: any): any {
    //TODO: complete types
    const object = {} as any;
    const { inbound, outbound } = (this.params as any) || {};
    const { filterType, value } = event || {};
    const { start, end } = value || {};

    switch (filterType) {
      case FlightsFilterTypeApiKeyEnum.connections:
        object[FlightsFilterTypeApiKeyEnum.connections] = value;
        break;
      case FlightsFilterTypeApiKeyEnum.inbound_arrival_time:
        object[FlightsFiltersApiKeyEnum.inbound] = {
          [FlightsFiltersApiKeyEnum.arrival_time]: {
            from: TimeUtil.formatLabel(start),
            to: TimeUtil.formatLabel(end),
          },
          [FlightsFiltersApiKeyEnum.departure_time]:
            inbound[FlightsFiltersApiKeyEnum.departure_time],
          date: inbound.date,
        };
        break;
      case FlightsFilterTypeApiKeyEnum.inbound_departure_time:
        object[FlightsFiltersApiKeyEnum.inbound] = {
          [FlightsFiltersApiKeyEnum.departure_time]: {
            from: TimeUtil.formatLabel(start),
            to: TimeUtil.formatLabel(end),
          },
          [FlightsFiltersApiKeyEnum.arrival_time]:
            inbound[FlightsFiltersApiKeyEnum.arrival_time],
          date: inbound.date,
        };
        break;
      case FlightsFilterTypeApiKeyEnum.outbound_arrival_time:
        object[FlightsFiltersApiKeyEnum.outbound] = {
          [FlightsFiltersApiKeyEnum.arrival_time]: {
            from: TimeUtil.formatLabel(start),
            to: TimeUtil.formatLabel(end),
          },
          [FlightsFiltersApiKeyEnum.departure_time]:
            outbound[FlightsFiltersApiKeyEnum.departure_time],
          date: outbound.date,
        };
        break;
      case FlightsFilterTypeApiKeyEnum.outbound_departure_time:
        object[FlightsFiltersApiKeyEnum.outbound] = {
          [FlightsFiltersApiKeyEnum.departure_time]: {
            from: TimeUtil.formatLabel(start),
            to: TimeUtil.formatLabel(end),
          },
          [FlightsFiltersApiKeyEnum.arrival_time]:
            outbound[FlightsFiltersApiKeyEnum.arrival_time],
          date: outbound.date,
        };
        break;

      default:
        break;
    }

    return object;
  }
  
  sortFlight(event: any) {
    const value = event.value;
    this.selectedSorting = value;
    this.sortAndFilter(this.selectedSorting, this.selectedFilters);
    this.quickFilterSelected = event.code;
    this.pageCount = 1;
  }
  
  sortAndFilter(sort: any, filter: any) {
    if ( !navigator.onLine ) {
      this.matDiaLog.open(OfflineDialogComponent);
      return;
    }
    this.facade.sortAndFilterFlights(sort, filter);
  }

  toggleClassToNearestElement(event: Event) {
    const button = event.target as HTMLButtonElement;
    const closestContainer = button.closest(".accrd");

    // Check if the closest ancestor with class 'container' is found
    if (closestContainer) {
      closestContainer.classList.toggle("open");
    }
  }

  toggleClass() {
    this.isOpen = !this.isOpen;
  }
  togglefltfunc() {
    this.toggleflt = !this.toggleflt;
  }
  togglesort() {
    this.showsort = !this.showsort;
  }
  validateRange(minPrice: number, maxPrice: number, changeVal?: boolean): void {
    this.maxPrice = maxPrice;
    this.minPrice = minPrice;

    if (minPrice > maxPrice) {
      // Swap Values
      let tempValue = maxPrice;
      this.maxPrice = maxPrice = minPrice;
      this.minPrice = minPrice = tempValue;
    }

    this.flightResults = this.fixedFlightResults.filter(
      (flight: any) =>
        flight.total_amount >= minPrice && flight.total_amount <= maxPrice
    );
    // Sort the filtered flights based on price
    this.flightResults.sort(
      (a: any, b: any) => a.total_amount - b.total_amount
    );
    this.cheapestFlight = this.flightResults[0];
    this.getFastestFlight(this.flightResults);
    this.updateContent("priceFilter");
  }

  getFastestFlight(flightData: any[]): void {
    let fastestFlightTime: any[] = [];
    for (let data of flightData) {
      let totalHours = 0;
      if (data.slices && data.slices[0]) {
        if (data.slices[0].duration.hasOwnProperty("days")) {
          let dayHours = +data.slices[0].duration.days * 24;
          let minuteHours = +data.slices[0].duration.minutes / 24;
          totalHours = minuteHours + dayHours + +data.slices[0].duration.hours;
        } else {
          let minuteHours = +data.slices[0].duration.minutes / 24;
          totalHours = minuteHours + +data.slices[0].duration.hours;
        }
      }
      fastestFlightTime.push({ time: totalHours, id: data.id });
    }
    fastestFlightTime.sort((a, b) => a.time - b.time);
    this.fastestFlight = flightData.find(
      (flight: any) => flight.id == fastestFlightTime[0].id
    );
  }
  getBestFlight(flightData: any[]): void {
    let fastestFlightTime = [];
    for (let data of this.flightResults) {
      let totalHours = 0;
      let stops = 0;
      if (data.slices && data.slices[0]) {
        stops = data.slices[0].segments.length - 1;
      }
      fastestFlightTime.push({ stops: stops, ...data });
    }
    const customSort = (a: any, b: any) => {
      if (a.stops === b.stops) {
        // If stops are equal, compare based on price
        return a.total_amount - b.total_amount;
      } else {
        // Otherwise, compare based on stops
        return a.stops - b.stops;
      }
    };
    fastestFlightTime.sort(customSort);
    this.bestFlight = fastestFlightTime[0];
  }
  type(event: any, evt: HTMLDivElement): void {
    this.cheapest.nativeElement.classList.remove("active");
    this.fastest.nativeElement.classList.remove("active");
    this.best.nativeElement.classList.remove("active");
    this.cheapest.nativeElement.classList.add("cAble");
    this.fastest.nativeElement.classList.add("cAble");
    this.best.nativeElement.classList.add("cAble");
    const card = evt;
    card.classList.add("active");
    card.classList.remove("cAble");
  }
  updateContent(data: any): void {
    if (data == "priceFilter") {
      this.changeDetectorRef.detectChanges();
    }
  }
  openpspopup(): void {
    const dialog = this.matDiaLog.open(TripSummaryComponent, {
      width: "90%",
      data: { searchData: this.data },
    });
  }

  closePopupps(): void {
    this.pspopup = false;
  }
  ClickedOutps(event: Event): void {
    const evt = event.target as HTMLButtonElement;
    if (evt.classList.contains("price-summary")) {
      this.pspopup = false;
    }
  }

  getEventCriteria(data:any){
      this.countryData.map((info) => {
        if (
          info.cityCode == data["destinationLocationCode"] ||
          info.countryCode == data["destinationLocationCode"]
        ) {
          // this.eventRequest.criteria.city = 1006;
          this.eventRequest.criteria.city = info.cityId;
        }
        if (
          info.cityCode == data["destinationLocationCode"] ||
          info.countryCode == data["destinationLocationCode"]
        ) {
          // this.eventRequest.criteria.country = 1003;
          this.eventRequest.criteria.country = info.countryId;
        }
        let inbound: string | any = this.datePipe.transform(
          new Date(data["inbound"]["date"]),
          "YYYY-MM-dd"
        );
        this.eventRequest.criteria.fromDate = inbound;
        let outbound: string | any = this.datePipe.transform(
          new Date(data["outbound"]["date"]),
          "YYYY-MM-dd"
        );
        this.eventRequest.criteria.toDate = outbound;
      });
  }

  getEventsData(eventId: string): void {    
    this.eventFacade.events$.subscribe((data) => {
      this.loadedEvent = data[eventId];
    });
  }

  filterSelection(filter: any): void {
    this.selectedFilters = JSON.parse(JSON.stringify(this.selectedFilters));
    if (filter.subOptionId && filter.subOptionId != null) {
      let obj: any = {};
      obj[filter.subOptionId] = filter.value;
      this.selectedFilters[filter.id] = {
        ...this.selectedFilters[filter.id],
        ...obj,
      };
    } else {
      this.selectedFilters[filter.id] = filter.value;
    }
    this.pageCount = 1;
    this.sortAndFilter(this.selectedSorting, this.selectedFilters);
    const base64Data = this.objectToBase64(this.selectedFilters);
    const currentUrlTree = this.router.parseUrl(this.router.url);
    const queryParams = { ...currentUrlTree.queryParams, flightFilter: encodeURIComponent(base64Data) };
    const updatedUrlTree = this.router.createUrlTree([], { queryParams, queryParamsHandling: 'merge' });
    const updatedUrl = this.router.serializeUrl(updatedUrlTree);
    window.history.replaceState({}, '', `/#${updatedUrl}`);
  }

  objectToBase64(obj: any): string {
    const jsonStr = JSON.stringify(obj);
    return btoa(jsonStr);
  }

  clearFilterPanel() {
    this.selectedFilters = {};
    this.sortAndFilter(this.selectedSorting, this.selectedFilters);
    const base64Data = this.objectToBase64({});
    const currentUrlTree = this.router.parseUrl(this.router.url);
    const queryParams = { ...currentUrlTree.queryParams, flightFilter: encodeURIComponent(base64Data) };
    const updatedUrlTree = this.router.createUrlTree([], { queryParams, queryParamsHandling: 'merge' });
    const updatedUrl = this.router.serializeUrl(updatedUrlTree);
    window.history.replaceState({}, '', `/#${updatedUrl}`);
  }

  clearSingle(event: any) {
    const { [event.info.id]: _, ...rest } = this.selectedFilters;
    this.selectedFilters = rest;
    this.sortAndFilter(this.selectedSorting, this.selectedFilters);
    const base64Data = this.objectToBase64({});
    const currentUrlTree = this.router.parseUrl(this.router.url);
    const queryParams = { ...currentUrlTree.queryParams, flightFilter: encodeURIComponent(base64Data) };
    const updatedUrlTree = this.router.createUrlTree([], { queryParams, queryParamsHandling: 'merge' });
    const updatedUrl = this.router.serializeUrl(updatedUrlTree);
    window.history.replaceState({}, '', `/#${updatedUrl}`);
  }

  filterFlights(flight: any): void {
    let tempFilterArray: any[] = JSON.parse(
      JSON.stringify(this.fixedFlightResults)
    );
    // for price
    if (flight.hasOwnProperty("price")) {
      tempFilterArray = tempFilterArray.filter(
        (item: any) =>
          item.total_amount >= flight.price.start &&
          item.total_amount <= flight.price.end
      );
      // Sort the filtered flights based on price
      tempFilterArray.sort((a: any, b: any) => a.total_amount - b.total_amount);
      this.cheapestFlight = tempFilterArray[0];
      this.getFastestFlight(tempFilterArray);
    }
    if (flight.hasOwnProperty("noOfStops")) {
      let array324: any[] = [];
      tempFilterArray = array324;
      for (let data of flight.noOfStops) {
        array324 = array324.concat(
          this.fixedFlightResults.filter(
            (item: any) => item.slices[0].segments.length - 1 == +data
          )
        );
      }
      tempFilterArray = array324;
    }

    this.flightResults = tempFilterArray;
    // this.sortEvents("cheapest");
  }
  onSubmitSearchForm(formDetails: FindTripFormGroupInterface): void {
    let copyFormDetails: any = { ...formDetails };
    const pipe = new DatePipe("en-US");
    copyFormDetails.inboundDate = pipe.transform(
      copyFormDetails.inboundDate,
      "yyyy-MM-dd"
    );
    copyFormDetails.outboundDate = pipe.transform(
      copyFormDetails.outboundDate,
      "yyyy-MM-dd"
    );
    copyFormDetails.destinationLocationCode =
      FormsMetadata.destination.optionsArray.find(
        (item) => item.displayName === formDetails.destinationLocationCode
      )?.value as string;
    copyFormDetails.originLocationCode = FormsMetadata.origin.optionsArray.find(
      (item) => item.displayName === formDetails.originLocationCode
    )?.value as string;
    if(copyFormDetails.paxesChildrenAges!=="null"){
      copyFormDetails.paxesChildrenAges = JSON.stringify(
        copyFormDetails.paxesChildrenAges
      );
    }
    
    const finalizedObject =HomePageUtils.finalizedObjectData(copyFormDetails);
    const finalizedObjectTemp =HomePageUtils.finalizedObjectDataTemp(copyFormDetails);
    let forwardRoute = PagesRoute.EventPage;
    this.routerService.navigateAndAddParamsToUrl(
      finalizedObjectTemp,
      true,
      forwardRoute
    );
  }

  quickFilter(event: any)
  {
    if(event === 'cheapest' && this.quickFilterSelected !== 'cheapest' )
    {
      const params = {
        value: 'total_amount'
      }
      this.sortFlight(params);
    } else if( event === 'fastest' && this.quickFilterSelected !== 'fastest' ){
      const params = {
        value: 'fastest'
      }
      this.sortFlight(params);
    } else if( event === 'best' && this.quickFilterSelected !== 'best' ) {
      const params = {
        value: 'best'
      }
      this.sortFlight(params);
    } else {
      this.loadedFlights = this.allLoadedFlights;
    }
    this.quickFilterSelected = event;
  }
  navigateToHomePage(): void {
    setTimeout(() => {
      this.globalStore.dispatch(ResetState());
      this.router.navigate(['/home-page']);
    }, 3000);
  }
  retryFilters(): void {
    this.handleNavigationEnd();
  }
  handleNavigationEnd(): void {
    const segments = this.router.url.split('/');
    const currentPath = segments[segments.length - 1].split('?')[0];
    if (currentPath === PagesRoute.FlightsPage) {
      this.showRetryBtn = true;
      this.globalStore.dispatch(FlightsStateActions.loadInitialFlightsData({ requestQuery: "Load Initial Flights Data" }));
      this.globalStore.dispatch(FlightsStateActions.loadMoreFlights({ requestQuery: "Load More Flights" }));
    }
  }
  refreshPage(): void {
    window.location.reload();
  }
  private getFilterState(): void {
    // Use ActivatedRoute or Service Observable to track filter state
    this.routerService.isFilterOptions$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (value: boolean) => {
        this.isFilterFailed = value;
      },
      error: (error) => {
        console.error('Error observing filter state:', error);
      },
    });
  }

  summaryEventSelection(event: any,flight: any){
    const combinedData = { event, flight };
    this.flightSummarySelection.emit(combinedData);
  }

  isSelectedFlight(flightOffer: any): boolean {
    let isSelected = false;  // Define a local flag to store the result
  
    // Subscribe to the flight$ observable
    this.facadeCheckout.flight$.pipe(takeUntil(this.destroy$)).subscribe((flights) => {
      // Check if the flight exists in the array
      if ( flights["id"] === flightOffer.id ) {
        isSelected = true;
      }
    });
  
    // Return the flag after the subscription completes
    return isSelected;
  }   

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
  
}
